import { ContactModalContent } from 'components/contact/contactNotificationModal/ContactModalContent'
import { useActualContact } from 'components/contact/contactUtils'
import { BlockSpinner } from 'components/spinner/Spinner'
import { useTranslation } from 'next-i18next'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'
import { ApiType } from 'utils/types'

//
// This modal is used for:
// - notifying the invite orignator that the invite has been accepted
// - telling a new user that they have just accepted the TC invite
//

export const ContactBoundModal = (props: {
  contact?: ApiType['TrustedContactResponse']
  type?: ApiType['TrustedContactUserResponse']['type']
}) => {
  const { isLoading } = useDynamicTranslations('dashboard')
  const { t } = useTranslation('dashboard')
  const { actualContact } = useActualContact(props.contact)

  const contactName = actualContact?.first_name || actualContact?.email

  if (isLoading) {
    return <BlockSpinner />
  }
  return (
    <ContactModalContent
      actualContact={actualContact}
      titleText={t('dashboard.contact_bound_modal_title', { who: contactName })}
      descriptionText={<>{t('dashboard.contact_bound_modal_desc')}</>}
    />
  )
}
